module.exports = __webpack_public_path__ + "static/media/LOGO_RGB.69fbdbae.png";